import { render, staticRenderFns } from "./PlayerIndexGames.vue?vue&type=template&id=1ce633dc&"
import script from "./PlayerIndexGames.vue?vue&type=script&lang=js&"
export * from "./PlayerIndexGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports